import type { IconSvgObject } from './types';

const TentIcon: IconSvgObject = [
  ["path", { d: "M12 14L8 21L16 21L12 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.99997 3L20.5726 16.4561C20.8495 16.8085 21 17.2436 21 17.6917V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 3L3.42733 16.4561C3.15047 16.8085 2.99997 17.2436 2.99997 17.6917V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 21H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default TentIcon;
